<div class="fab-container">
  <button mat-mini-fab class="map-fab-toggler" (click)="onToggleFab()">
    <mat-icon [@fabToggler]="{ value: fabTogglerState }">map</mat-icon>
  </button>

  <div class="fab-buttons-container" [hidden]="isHidden">
    <ng-content></ng-content>
  </div>
</div>
